import { NextRouter } from "next/router"

export type AppVersion = "v4"

export const determineAppVersion = (router: NextRouter): AppVersion => {
    if (router.pathname.includes("/v4/")) return "v4"
    return "v4"
}
